<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.cardTicketDeletedList.push"
    :query-list="queryList"
    :is-show-store-select="true"
    :is-store-select-clearable="true"
    store-select-label="退券门店"
    :is-show-administrator-select="true"
    administrator-select-label="退券申请人"
    :is-show-student-select="true"
    student-select-label="退券学员"
    :is-show-quick-time-tab="true"
    :is-show-quick-time-tab-last-thirty-day="true"
    quick-time-tab-label="退券日期"
  >
    <template slot="header-item">
      <div class="flex-align-center flex-wrap table-filter-item">
        <div class="flex-align-center table-filter-label">仅显示录入错误：</div>
        <el-switch
          v-model="queryList.is_input_error"
          :active-value="1"
          :inactive-value="0"
          @change="handleInputErrorChange"
        />
      </div>
    </template>

    <v-column-time value="退券通过时间"/>
    <el-table-column label="课次券类型" prop="card_ticket_type_name" width="150"/>
    <v-column-student label="退券学员" link-page-id="student_id"/>
    <el-table-column label="办券门店" prop="store_name" width="150"/>
    <v-column-avatar
      label="退券申请人"
      avatar-key="request_administrator_avatar"
      nickname-key="request_administrator_nickname"
    />
    <v-column-avatar
      label="退券通过人"
      avatar-key="review_administrator_avatar"
      nickname-key="review_administrator_nickname"
    />
    <el-table-column label="退款金额" align="center">
      <template v-slot="{row}">{{ row.del_payment | toYuan }}</template>
    </el-table-column>
    <el-table-column label="退券原因" prop="reason"/>
    <el-table-column label="录入错误" width="90" align="center">
      <template v-slot="{ row }">
        <el-tag v-if="row.is_input_error" type="danger" size="small">是</el-tag>
        <el-tag v-else type="info" size="small">否</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="原因截图">
      <template v-slot="{ row }">
        <el-image
          v-if="row.reason_img"
          :src="row.reason_img"
          style="width: 27px;height: 60px;"
          fit="cover"
        />
      </template>
    </el-table-column>

    <v-column-time value="失效日期" field="expire_time" time-format="timeToYmd" empty-tip="-" sortable="" align="center"/>
    <el-table-column label="剩余次数（次）" align="center">
      <template v-slot="{ row }">
        <span>{{ row.expire_number | toYuan }}</span>
      </template>
    </el-table-column>

    <el-table-column label="操作" width="244px">
      <template v-slot="{ row }">
        <v-list-button name="查看" icon="browse" :to="RouteConfig.cardTicketDeleteRecordDetail.to(row.id)"/>
      </template>
    </el-table-column>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-ticket-deleted-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>退券通过时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>课次券类型</span>
              <span>{{ v.card_ticket_type_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>退券学员</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.student_id"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>办券门店</span>
              <span>{{ v.store_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>退券申请人</span>
              <v-avatar-nickname
                :value="v.request_administrator_avatar"
                :nickname="v.request_administrator_nickname"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>退券通过人</span>
              <v-avatar-nickname
                :value="v.review_administrator_avatar"
                :nickname="v.review_administrator_nickname"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>退款金额</span>
              <span>{{ v.del_payment | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>退券原因</span>
              <span>{{ v.reason }}</span>
            </div>
            <div class="list-item-detail">
              <span>录入错误</span>
              <el-tag v-if="v.is_input_error" type="danger" size="small">是</el-tag>
              <el-tag v-else type="info" size="small">否</el-tag>
            </div>
            <div class="list-item-detail">
              <span>原因截图</span>
              <el-image
                v-if="v.reason_img"
                :src="v.reason_img"
                style="width: 27px;height: 60px;"
                fit="cover"
              />
              <span v-else>-</span>
            </div>
            <div class="list-item-detail">
              <span>失效日期</span>
              <span>{{ v.expire_time | timeToYmd }}</span>
            </div>
            <div class="list-item-detail">
              <span>剩余次数（次）</span>
              <span>{{ v.expire_number | toYuan }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button name="查看" icon="browse" :to="RouteConfig.cardTicketDeleteRecordDetail.to(v.id)"/>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { index } from '@/api/card-ticket-del-record';
import { getLegalQueryList } from '@/utils/formats';

export default {
  name: RouteConfig.cardTicketDeletedList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    count: 0,
    list: [],
    xlsData: [],
    isStoringIds: [],
    queryList: {
      is_input_error: 0,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
      'defaultStoreId',
    ]),
  },
  beforeMount() {
    this.load();
  },
  methods: {
    refresh() {
      RouteConfig.cardTicketDeletedList.push(this.queryList);
    },
    handleStoreChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handleInputErrorChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      queryList.store_id = this.defaultStoreId;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
  },
};
</script>
